import { render, staticRenderFns } from "./MovimientoItem.vue?vue&type=template&id=07d80c57&scoped=true"
import script from "./MovimientoItem.vue?vue&type=script&lang=js"
export * from "./MovimientoItem.vue?vue&type=script&lang=js"
import style0 from "./MovimientoItem.vue?vue&type=style&index=0&id=07d80c57&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d80c57",
  null
  
)

export default component.exports